// @flow strict

export const appEnvironment = 'production';

// The API urls, deprecated in favor of the appEnvironment+frontend apis package
export const API_URL = 'https://ms-api-dot-gcp-sqo-solvextract-p.appspot.com';
export const API_VER = '/api/';

// User Authorization and Authentication:
export const firebaseConfig = {
    apiKey: 'AIzaSyDthfwwbQXoMcQKLsVmuhxfTWvW081amVA',
    authDomain: 'gcp-sqo-solvextract-p.firebaseapp.com',
    projectId: 'gcp-sqo-solvextract-p',
};

// Google tracking:
export const gaTrackingId = '';

// Used to replace Login UI, for application blocking (must contain content to block application)
export const appBlockingMessage = '';


export const PIWIK_PRO_TRACKERID = '37978e9c-5807-4ca6-9d50-2b1a3819bd7a';
export const PIWIK_PRO_API_URL = 'https://solvay.containers.piwik.pro';
export const NAVBAR_DASHBOARD_V2_REDIRECT = true;

/**
 * A list of users allowed to use MinChem V2
 * The list should be an array of emails.
 */
export const MINCHEM_V2_TEST_USER_EMAILS = [
    "dverdi1@fmi.com"
];